import { action, computed } from 'mobx'
import { type WorkspacePosting } from './WorkspacePosting'
import { type StaffingSearchViewModel } from './StaffingSearchViewModel'
import { type StaffingDetailsViewModel } from '@/features/admin/staffing/components/StaffingDetailsPanel/StaffingDetailsViewModel'

/**
 * A row in the staffing table.
 */
export class WorkspacePostingItemViewModel {
  constructor(
    readonly workspacePosting: WorkspacePosting,
    private readonly _searcher: StaffingSearchViewModel,
    private readonly _detailsVm: StaffingDetailsViewModel,
  ) {}

  /**
   * Whether the posting is selected for bulk actions.
   */
  @computed
  get isSelected() {
    return this._searcher.isSelected(this.workspacePosting)
  }

  /**
   * Toggles whether the posting is selected for bulk actions.
   */
  @action.bound
  toggleSelected() {
    this._searcher.togglePosting(this.workspacePosting)
  }

  /**
   * Shows the posting in the details panel.
   */
  @action.bound
  select() {
    void this._detailsVm.show(this.workspacePosting)
  }
}
